module.exports = __webpack_public_path__ + "img/logo.a0b70eca.png";